import React, { useRef } from "react";
import classNames from "classnames"
import { CurrentlyViewingProps } from "./types";
import { NoSSRComponent } from '@/migrated-widgets/table-map/utils/ssr';
import { CloseIcon } from "@/migrated-widgets/table-map/components/icons/CloseIcon";

function CurrentlyViewing({ onClick, viewing = '' }: CurrentlyViewingProps) {
    return(
        <>
            <header className={classNames('flex', 'bg-table-map-gray', 'border-b', 'border-b-brand-lightGray', 'sticky', 'top-0', 'z-10')}>
                <div className={classNames('flex', 'justify-between', 'px-10', 'w-full', 'items-center', 'py-3')}>
                    <p className={classNames('font-bold', 'text-sm', 'tracking-[-0.15]', 'text-white')}>
                        {viewing}
                    </p>
                    <CloseIcon className="cursor-pointer" onClick={onClick} />
                </div>
            </header>
        </>
    )
}

export default NoSSRComponent<CurrentlyViewingProps>(CurrentlyViewing);
